import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';

export const UtcDateFormatter = (string : string) => {
  dayjs.extend(utc);
  if (!string) {
    return "";
  }
  return `${dayjs(string).utc().format("YYYY-MM-DD HH:mm:ss")} (UTC)`;
};

export const setStartFormat = (date : Date) => {
  dayjs.extend(utc);
  return dayjs(date).utc(true).startOf('date').toDate();
};

export const setEndFormat = (date : Date) => {
  dayjs.extend(utc);
  return dayjs(date).utc(true).endOf('date').toDate();
};

/**
 * 시작~끝 범위가 maxDays(달력일, 양끝 포함)를 넘으면 끝을 기준으로 시작을 당겨
 * 범위 안으로 맞춘다. 넘지 않으면 그대로 돌려준다.
 */
export const clampRangeToMaxDays = (
  startDate: Date,
  endDate: Date,
  maxDays: number
): { startDate: Date; endDate: Date } => {
  const start = dayjs(startDate).startOf("day");
  const end = dayjs(endDate).startOf("day");
  const days = end.diff(start, "day") + 1;
  if (days <= maxDays) return { startDate, endDate };
  return {
    startDate: end.subtract(maxDays - 1, "day").toDate(),
    endDate,
  };
};
